import { message, Spin, Switch } from "antd";
import AntdTablePro from "components/antdTablePro";
import { debounce } from "lodash";
import { Brand, useBrandList, useBrandUpdate } from "hooks/queries/useBrand";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AddCarBrand from "./AddCarBrand";

type FilterParams = {
  search: string;
};

function Index() {
  const [filterParams, setFilterParams] = useState<FilterParams>({
    search: "",
  });

  const { data, isLoading } = useBrandList();
  const { t } = useTranslation();

  const filteredData = data?.filter((item) =>
    item.name.toLowerCase().includes(filterParams.search.toLowerCase())
  );

  const columns = [
    {
      title: t("carList:carBrand"),
      dataIndex: "name",
    },
    {
      title: <div>{t("carList:status")}&nbsp;</div>,
      render: (_, row: Brand) => {
        return <StatusSwitch brand={row} />;
      },
    },
  ];

  const getSearchKeywordsDeb = debounce((value: string) => {
    setFilterParams({ search: value });
  }, 500);

  if (isLoading) return <Spin />;

  return (
    <React.Fragment>
      <AntdTablePro
        columns={columns}
        rowKey="id"
        dataSource={filteredData}
        toolBarRender={[<AddCarBrand key={1} />]}
        inputElement={{
          placeholder: t("main:search"),
          handleChange: (e) => getSearchKeywordsDeb(e.target.value),
          handleSearch: (value) => setFilterParams({ search: value }),
        }}
      />
    </React.Fragment>
  );
}

export default Index;

function StatusSwitch({ brand }: { brand: Brand }) {
  const { t } = useTranslation();
  const { mutate, isLoading } = useBrandUpdate(brand.id);

  const [optimisticCheck, setOptimisticCheck] = useState(!brand.isDisabled);

  const onChange = (v: boolean) => {
    setOptimisticCheck(v);
    mutate(
      { isDisabled: !v },
      {
        onSuccess: () => {
          message.success(t("carList:messages.updateSuccessfully"));
        },
        onError: () => {
          setOptimisticCheck((v) => !v);
          message.error(t("carList:messages.updateFailed"));
        },
      }
    );
  };

  return (
    <Switch
      checked={optimisticCheck}
      onChange={onChange}
      disabled={isLoading}
      className={optimisticCheck ? "bg-primary" : ""}
    />
  );
}
